import React, { useEffect, useState } from "react";
import { useShareLoan } from "../../hooks/contexts/share-loan-hooks";
import { Modal, Button } from "react-bootstrap";
import ErrorModal from "./ErrorModal";
import Spinner from "react-bootstrap/Spinner";
import GoodLeapTPOModal from "./GoodLeapTPOModal";
import "./LoanApplyModal.css";

/**
 * Launches and displays a modal which uses the usShareLoan Provider to connect to application link
 *
 * @callback onHideCallBack
 * @param {onHideCallback} onHide Callback to hide the modal when closed
 * @param {boolean} show Determines if the modal is loaded and shown
 * @returns {React.JSX.Element}
 */
export default function LoanApplyModal({
  onHide,
  show,
  isChangeOrder,
  loanA,
  sfProjectId,
  applied,
  setApplied,
}) {
  const {
    response,
    isLoading,
    updateLoanId,
    errorMessage,
    changeOrderMessage,
    shareLoan,
    success,
  } = useShareLoan();

  useEffect(() => console.log(changeOrderMessage), [changeOrderMessage]);

  useEffect(() => {
    if (!isLoading && !loanA.loanName.toLowerCase().includes("goodleap")) {
      shareLoan();
    }
  }, []);

  useEffect(() => {
    if (
      loanA.loanName.toLowerCase().includes("goodleap") &&
      !applied &&
      !isLoading
    ) {
      updateLoanId();
      return;
    }
    if (!isLoading) updateLoanId();
  }, [isLoading]);

  const titleText = () => {
    if (isChangeOrder) {
      return <p>Syncing and Submiting Change Order...</p>;
    } else {
      return <p>Syncing Application...</p>;
    }
  };
  const getBodyText = () => {
    if (isChangeOrder) {
      return <p>{changeOrderMessage}</p>;
    }

    return (
      <p>
        <Spinner size="sm" /> Application Will Open in a New Tab
      </p>
    );
  };

  if (loanA.loanName.toLowerCase().includes("goodleap")) {
    return errorMessage ? (
      <ErrorModal errorMessage={errorMessage} onHideParent={onHide} />
    ) : (
      <GoodLeapTPOModal
        onHide={onHide}
        show={show}
        isChangeOrder={isChangeOrder || applied}
        loanA={loanA}
        sfProjectId={sfProjectId}
        changeOrder={{
          changeOrderMessage,
          shareLoan,
          errorMessage,
          isLoading,
          applied,
          setApplied,
          response,
          updateLoanId,
          success,
        }}
      />
    );
  }

  return errorMessage ? (
    <ErrorModal errorMessage={errorMessage} onHideParent={onHide} />
  ) : (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{titleText()}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{getBodyText()}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
